export default {
      id: "coverage-usage",
      viewBox: "0 0 38 32",
      url: __webpack_public_path__ + "sprite.svg#coverage",
      toString: function () {
        return this.url;
      }
    }